// console.log(`webform.js is working!`);

const schoolLocation = document.querySelector(`#school-location`);

function getSelectedOption(selectOptions) {
  let opt;
  for (let i = 0, len = selectOptions.options.length; i < len; i++) {
    opt = selectOptions.options[i];
    if (opt.selected === true) {
      break;
    }
  }
  return opt;
}

function displayWebformLoadingScreen() {
  let loadingScreen = document.querySelector(`.webform-loading-screen`);
  loadingScreen.classList.remove(`disabled`);
  loadingScreen.classList.add(`start-spin`);
  setTimeout(() => {
    loadingScreen.classList.add(`disabled`);
    loadingScreen.classList.remove(`start-spin`);
  }, 750);
}

const setLocationFormHeight = (schoolInfo) => {
  let formContainerHeight = [...schoolInfo].map((e) => e.clientHeight);
  let maxContainerHeight = Math.max.apply(Math, formContainerHeight);
  let formContainer = document.querySelectorAll(`.webform-location-forms`);
  formContainer.forEach((form) => {
    form.style.height = maxContainerHeight + `px`;
  });
};

function changeSelectedLocation(schoolLocation) {
  schoolLocation.addEventListener(`change`, function () {
    let selectedOption = getSelectedOption(schoolLocation);
    let schoolInfo = document.querySelectorAll(`.location-information`);

    schoolInfo.forEach((schoolElement) => {
      if (schoolElement.classList.contains(selectedOption.value)) {
        displayWebformLoadingScreen();
        setTimeout(() => {
          schoolElement.classList.remove(`inactive-school`);
        }, 750);
      } else {
        schoolElement.classList.add(`inactive-school`);
      }
    });
  });
}

if (schoolLocation) {
  const schoolInfo = document.querySelectorAll(`.location-information`);
  setLocationFormHeight(schoolInfo);
  changeSelectedLocation(schoolLocation);
}
